import React from 'react';
import './CarouselComponent.css'
function CarouselComponent({ images }) {
    return (
        <div id="carouselIndicators" className="carousel slide mb-5" data-bs-ride="carousel">
            <div className="carousel-indicators">
                {images.map((_, idx) => (
                    <button
                        key={idx}
                        type="button"
                        data-bs-target="#carouselIndicators"
                        data-bs-slide-to={idx}
                        className={idx === 0 ? 'active' : ''}
                        aria-current={idx === 0}
                        aria-label={`Slide ${idx + 1}`}
                    ></button>
                ))}
            </div>
            <div className="carousel-inner">
                {images.map((img, idx) => (
                    <div key={idx} className={`carousel-item ${idx === 0 ? 'active' : ''}`}>
                        <img src={img.src} className="d-block w-100" alt={img.alt || `Slide ${idx + 1}`} />
                        <div className="overlay-dark"></div>
                        <div className="carousel-caption-custom">
                            <h1>Cisono,</h1>
                            <h1>per davvero</h1>
                        </div>
                    </div>
                ))}
            </div>
            <button className="carousel-control-prev" type="button" data-bs-target="#carouselIndicators" data-bs-slide="prev">
                <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Precedente</span>
            </button>
            <button className="carousel-control-next" type="button" data-bs-target="#carouselIndicators" data-bs-slide="next">
                <span className="carousel-control-next-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Successiva</span>
            </button>
        </div>
    );
}

export default CarouselComponent;
